<template>
    <div class="de-corner-border">
        <span class="border-linear border-top-left"></span>
        <span class="border-linear border-top-right"></span>
        <span class="border-linear border-bottom-left"></span>
        <span class="border-linear border-bottom-right"></span>
        <slot></slot>
    </div>
</template>
<script>
import './index.less';
export default {
    name: 'CornerBorder'
}
</script>